import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, of } from "rxjs";
import { QuoteService } from "../services/quote.service";
import { Quote } from "../../shared/models/quote.interface";
import { settings } from "../../shared/constants/settings";
import { catchError, finalize } from "rxjs/operators";
import { QuoteFilter } from "../models/quote.filter";

export class QuotesDataSource implements DataSource<Quote> {
  private quotesSubject = new BehaviorSubject<Quote[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private quoteService: QuoteService) { }

  connect(collectionViewer: CollectionViewer): Observable<Quote[]> {
    return this.quotesSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.quotesSubject.complete();
    this.loadingSubject.complete();
  }

  loadQuotes(filter: QuoteFilter,
    sortColumn = 'projectName', sortDirection = 'asc', pageIndex = 0) {

    this.loadingSubject.next(true);

    this.quoteService.getList(filter, sortColumn, sortDirection, pageIndex).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(lessons => this.quotesSubject.next(lessons));
  }    
}
